import { useEffect, useRef } from 'react';

import { useAppDispatch } from 'app/store/store';
import { setAppBarHeight } from 'app/store/reducers/app/main-layouts/appbar';

export const useAppbarRef = () => {
  const appBarRef = useRef(null);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setAppBarHeight(appBarRef.current.clientHeight));
  }, []);
  return appBarRef;
};
